import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TrialBanner: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Only show banner if user is on assessment_only plan
  if (!user?.client || user.client?.subscription_plan !== 'assessment_only') {
    return null;
  }

  const handleLearnMore = () => {
    // Preserve assessment context from URL (if present)
    const assessmentId = searchParams.get('assessment_id');
    const token = searchParams.get('token');

    if (assessmentId && token) {
      // Pass assessment context to trial signup
      navigate(`/hub/trial-info?assessment_id=${assessmentId}&token=${token}`);
    } else {
      // No assessment context, just go to trial info
      navigate('/hub/trial-info');
    }
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 dark:from-blue-700 dark:to-indigo-800">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex-1">
            <p className="text-white text-sm sm:text-base font-medium">
              You are seeing demo data. Only the Assessment functionality is available.
            </p>
            <p className="text-white text-xs sm:text-sm mt-1 opacity-90">
              Take a test drive of Aivilo Lens for 60 days, connect your AWS account and get full platform access.
            </p>
          </div>
          <button
            onClick={handleLearnMore}
            className="flex-shrink-0 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 dark:bg-gray-100 dark:hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-600 focus:ring-white transition-colors ml-4 mt-2 sm:mt-0"
          >
            Learn More
            <svg
              className="ml-2 -mr-1 h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;
